<template>
  <div class="safeDriving">
    <p class="text">
     如果车辆租赁期间出险，保险核定损失小于8000元（含8000元）的，客户无需承担保险理赔范围内的任何费用；保险核定损失大于8000元的，客户无需承担保险理赔范围内的任何费用，但需承担车损总额20%的加速折旧费。本服务按天计费，最高7天封顶（租期大于7天只需支付7天的费用，便可以享受租期全程的驾无忧保障）。不在保障范围内：1、无事故证明、无保险理赔资料；2、车辆租期内车辆零部件丢失、轮胎及轮毂的损坏、玻璃单独破损、锁芯损坏。3、因车损产生的停运损失费、折旧费；4、其他保险公司无需承担或责任免除的费用。
    </p>
  </div>
</template>

<script>
export default {
  name: "safeDriving"
}
</script>

<style scoped>
.safeDriving {
  font-size: 24px;
}
</style>